<template>
  <div ref="mainDivNav" class="w-100">
    <div v-if="isLoading" class="loading-animation">
      <div class="loading-card">
        <b-spinner class="loading-spinner" label="Loading" />
        <span class="loading-text">Loading...</span>
      </div>
    </div>
    <template v-if="clusterState !== 0 || projectState !== 0 || displayingType !== DISPLAYING_CLUSTERS">
      <b-container v-if="clusterState === 1 && displayingType === DISPLAYING_PROJECTS">
        <b-row>
          <div class="mx-3 my-2">
            <b-breadcrumb>
              <b-breadcrumb-item to="/navigation"> <b-icon icon="house-fill" />My Clusters </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-row>
        <b-row>
          <b-col class="mx-3 col-lg-8 col-md-10 col-sm-12">
            <b-row>
              <b-card class="mb-4 mt-2 custom-card">
                <!-- Button to trigger the email request -->
                <b-card-header class="d-flex align-items-center p-2">
                  <b-card-title class="h4 mb-0 ml-2 text-danger">
                    <b-icon icon="exclamation-triangle" class="text-warning bg-danger" /><span class="font-weight-bold"> Resource Inaccessible!</span>
                  </b-card-title>
                </b-card-header>
                <b-card-body class="text-justify">
                  <span class="font-weight-bold">Insufficient Permission!</span>
                  Either the owner has not shared the report with the current user or the resource doesn't exist. Please send an email request to the owner to get access to the report.
                </b-card-body>
                <div class="d-flex justify-content-end">
                  <b-button variant="primary" @click="showPopup"> Send Request </b-button>
                </div>
              </b-card>
            </b-row>
            <b-row>
              <div>
                <b-modal v-model="showingPopup" title="Request Resource Access" :header-bg-variant="headerBgVariant" hide-footer>
                  <b-form @submit.stop.prevent="sendAccessRequest">
                    <b-form-group
                      label="Email*:"
                      label-for="email-input"
                      label-cols-sm="4"
                      label-cols-lg="2"
                      class="mb-3"
                      :state="emailValid ? null : false"
                      :invalid-feedback="emailValid ? null : 'Please enter a valid email address.'"
                    >
                      <b-form-input id="email-input" v-model="receiver" required type="email" placeholder="email" disabled />
                    </b-form-group>
                    <b-form-group label="Access to*:" label-for="resource-type" label-cols-sm="4" label-cols-lg="2" class="mb-3">
                      <b-form-select id="resource-type" v-model="resourceType" :options="resourceItems" placeholder="select resource" required />
                    </b-form-group>
                    <b-form-group label="Message:" label-for="message-textarea" label-cols-sm="4" label-cols-lg="2" class="mb-3">
                      <b-form-textarea id="message-textarea" v-model="messageBody" rows="5" placeholder="Enter your message" />
                    </b-form-group>
                    <div class="d-flex justify-content-end">
                      <b-button type="submit" variant="primary" class="mx-2"> Send </b-button>
                      <b-button type="button" variant="secondary" @click="closePopup"> Cancel </b-button>
                    </div>
                  </b-form>
                </b-modal>
                <b-modal v-model="showingSendingRequest" title="Sending Request" hide-footer centered>
                  <div class="text-center">
                    <b-spinner variant="primary" class="mb-3" />
                    <p>Your request is being sent. Please wait...</p>
                  </div>
                </b-modal>
              </div>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <b-container v-else-if="clusterState === 2 && displayingType === DISPLAYING_PROJECTS">
        <b-row>
          <div class="mx-3 my-2">
            <b-breadcrumb>
              <b-breadcrumb-item to="/navigation"> <b-icon icon="house-fill" />My Clusters </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-row>
        <b-row>
          <b-col class="mx-3 col-lg-8 col-md-10 col-sm-12">
            <b-row>
              <b-card class="mb-4 mt-2 custom-card">
                <!-- Button to trigger the email request -->
                <b-card-header class="d-flex align-items-center p-2">
                  <b-card-title class="h4 mb-0 ml-2 text-danger">
                    <b-icon icon="exclamation-triangle" class="text-warning bg-info" /><span class="font-weight-bold"> No Cluster exists with the current selection!</span>
                  </b-card-title>
                </b-card-header>
                <b-card-body class="text-justify"> <span class="font-weight-bold">Please</span> make sure to select a cluster that exists and you are authorized to access it. </b-card-body>
              </b-card>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <b-container v-if="projectState === 1 && displayingType === DISPLAYING_REPORTS">
        <b-row>
          <div class="mx-3 my-2">
            <b-breadcrumb>
              <b-breadcrumb-item to="/navigation"> <b-icon icon="house-fill" />My Clusters </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-row>
        <b-row>
          <b-col class="mx-3 col-lg-8 col-md-10 col-sm-12">
            <b-row>
              <b-card class="mb-4 mt-2 custom-card">
                <!-- Button to trigger the email request -->
                <b-card-header class="d-flex align-items-center p-2">
                  <b-card-title class="h4 mb-0 ml-2 text-danger">
                    <b-icon icon="exclamation-triangle" class="text-warning bg-danger" /><span class="font-weight-bold"> Resource Inaccessible!</span>
                  </b-card-title>
                </b-card-header>
                <b-card-body class="text-justify">
                  <span class="font-weight-bold">Insufficient Permission!</span>
                  Either the owner has not shared the project with the current user or the resource doesn't exist. Please send an email request to the owner to get access to the project.
                </b-card-body>
                <div class="d-flex justify-content-end">
                  <b-button variant="primary" @click="showPopup"> Send Request </b-button>
                </div>
              </b-card>
            </b-row>
            <b-row>
              <div>
                <b-modal v-model="showingPopup" title="Request Resource Access" :header-bg-variant="headerBgVariant" hide-footer>
                  <b-form @submit.stop.prevent="sendAccessRequest">
                    <b-form-group
                      label="Email*:"
                      label-for="email-input"
                      label-cols-sm="4"
                      label-cols-lg="2"
                      class="mb-3"
                      :state="emailValid ? null : false"
                      :invalid-feedback="emailValid ? null : 'Please enter a valid email address.'"
                    >
                      <b-form-input id="email-input" v-model="receiver" required type="email" placeholder="email" disabled />
                    </b-form-group>
                    <b-form-group label="Access to*:" label-for="resource-type" label-cols-sm="4" label-cols-lg="2" class="mb-3">
                      <b-form-select id="resource-type" v-model="resourceType" :options="resourceItems" placeholder="select resource" required />
                    </b-form-group>
                    <b-form-group label="Message:" label-for="message-textarea" label-cols-sm="4" label-cols-lg="2" class="mb-3">
                      <b-form-textarea id="message-textarea" v-model="messageBody" rows="5" placeholder="Enter your message" />
                    </b-form-group>
                    <div class="d-flex justify-content-end">
                      <b-button type="submit" variant="primary" class="mx-2"> Send </b-button>
                      <b-button type="button" variant="secondary" @click="closePopup"> Cancel </b-button>
                    </div>
                  </b-form>
                </b-modal>
              </div>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <b-container v-else-if="projectState === 2 && displayingType === DISPLAYING_REPORTS">
        <b-row>
          <div class="mx-3 my-2">
            <b-breadcrumb>
              <b-breadcrumb-item to="/navigation"> <b-icon icon="house-fill" />My Clusters </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-row>
        <b-row>
          <b-col class="mx-3 col-lg-8 col-md-10 col-sm-12">
            <b-row>
              <b-card class="mb-4 mt-2 custom-card">
                <!-- Button to trigger the email request -->
                <b-card-header class="d-flex align-items-center p-2">
                  <b-card-title class="h4 mb-0 ml-2 text-danger">
                    <b-icon icon="exclamation-triangle" class="text-warning bg-info" /><span class="font-weight-bold"> No Project exists with the current selection!</span>
                  </b-card-title>
                </b-card-header>
                <b-card-body class="text-justify"> <span class="font-weight-bold">Please</span> make sure to select a project that exists and you are authorized to access it. </b-card-body>
              </b-card>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <template v-if="displayingType === DISPLAYING_CLUSTERS || (displayingType === DISPLAYING_PROJECTS && clusterState === 0) || (displayingType === DISPLAYING_REPORTS && projectState === 0)">
      <b-container fluid class="mt-2">
        <b-card
          v-if="(displayingType === DISPLAYING_CLUSTERS || displayingType === DISPLAYING_PROJECTS || displayingType === DISPLAYING_REPORTS) && isAbove500px"
          :class="['floating-card', 'sticker-container', cardSizeClass]"
        >
          <b-card-header v-b-toggle.collapseContent class="d-flex align-items-center p-2">
            <b-icon icon="list" />
            <b-card-title class="h7 mb-0 ml-2 text-primary">
              <span class="font-weight-bold">{{ displayinTypeText }}s Info</span>
            </b-card-title>
          </b-card-header>
          <b-collapse id="collapseContent">
            <b-card-body bg-variant="light" text-variant="dark" header="Cluster Projects">
              <b-card-text>
                <ul>
                  <li v-if="displayinTypeText === 'Project'">
                    <span class="font-weight-bold">Cluster Name:</span>
                    <b-badge variant="primary" pill>
                      {{ getNameCurrClusterNavigation }}
                    </b-badge>
                  </li>
                  <li v-else-if="displayinTypeText === 'Report'">
                    <span class="font-weight-bold">Project Name:</span>
                    <b-badge variant="primary" pill>
                      {{ getNameCurrProjectNavigation }}
                    </b-badge>
                  </li>
                  <li v-if="displayinTypeText === 'Project'">
                    <span class="font-weight-bold">Cluster Ownership:</span>
                    <b-badge variant="primary" pill>
                      {{ clusterOwnership }}
                    </b-badge>
                  </li>
                  <li v-else-if="displayinTypeText === 'Report'">
                    <span class="font-weight-bold">Project Ownership:</span>
                    <b-badge variant="primary" pill>
                      {{ projectOwnership }}
                    </b-badge>
                  </li>
                  <li v-if="displayinTypeText === 'Project'">
                    <span class="font-weight-bold">Cluster Owner:</span>
                    <b-badge variant="primary" pill>
                      {{ clusterOwnedBy }}
                    </b-badge>
                  </li>
                  <li v-else-if="displayinTypeText === 'Report'">
                    <span class="font-weight-bold">Project Owner:</span>
                    <b-badge variant="primary" pill>
                      {{ projectOwnedBy }}
                    </b-badge>
                  </li>
                  <li v-if="displayinTypeText === 'Cluster'">
                    <span class="font-weight-bold">Total Clusters:</span>
                    <b-badge variant="primary" pill>
                      {{ totalClusters }}
                    </b-badge>
                  </li>
                  <li v-else-if="displayinTypeText === 'Project'">
                    <span class="font-weight-bold">Total Projects:</span
                    ><b-badge variant="primary" pill>
                      {{ totalProjects }}
                    </b-badge>
                  </li>
                  <li v-else-if="displayinTypeText === 'Report'">
                    <span class="font-weight-bold">Total Reports:</span
                    ><b-badge variant="primary" pill>
                      {{ totalReports }}
                    </b-badge>
                  </li>
                  <li v-if="displayinTypeText === 'Cluster'">
                    <span class="font-weight-bold">Own Clusters:</span>
                    <b-badge variant="primary" pill>
                      {{ totalClustersOwned }}
                    </b-badge>
                  </li>
                  <li v-if="displayinTypeText === 'Cluster'">
                    <span class="font-weight-bold">Shared Clusters:</span>
                    <b-badge variant="primary" pill>
                      {{ totalClustersShared }}
                    </b-badge>
                  </li>
                  <li v-if="displayinTypeText === 'Project'">
                    <span class="font-weight-bold">Own Projects:</span>
                    <b-badge variant="primary" pill>
                      {{ totalProjectsOwned }}
                    </b-badge>
                  </li>
                  <li v-if="displayinTypeText === 'Project'">
                    <span class="font-weight-bold">Shared Projects:</span>
                    <b-badge variant="primary" pill>
                      {{ totalProjectsShared }}
                    </b-badge>
                  </li>
                </ul>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-row class="align-items-center mb-2">
          <router-link
            v-b-tooltip.hover
            :title="displayingType === DISPLAYING_PROJECTS ? 'Back to Cluster' : 'Back to Projects'"
            :to="displayingType === DISPLAYING_PROJECTS ? `/navigation` : `/navigation/${routeList[0]}`"
            class="back-btn"
            :style="{
              visibility: displayingType === DISPLAYING_PROJECTS || displayingType === DISPLAYING_REPORTS ? 'visible' : 'hidden',
            }"
          >
            <b-icon icon="arrow-left-short" />Back
          </router-link>
        </b-row>
        <b-row class="align-items-center">
          <b-breadcrumb>
            <b-breadcrumb-item to="/navigation"> <b-icon icon="house-fill" />My Djuli Clusters </b-breadcrumb-item>
            <b-breadcrumb-item
              v-if="displayingType <= DISPLAYING_REPORTS && routeList.length > 0"
              :to="`/navigation/${routeList[0]}`"
              :active="displayingType <= DISPLAYING_REPORTS && routeList.length === 1 ? true : false"
            >
              {{ breadcrumbClusterName }}
            </b-breadcrumb-item>
            <b-breadcrumb-item
              v-if="displayingType <= DISPLAYING_REPORTS && routeList.length > 1"
              :to="`/navigation/${routeList[0]}/${routeList[1]}`"
              :active="displayingType <= DISPLAYING_REPORTS && routeList.length > 1 ? true : false"
            >
              {{ breadcrumbProjectName }}
            </b-breadcrumb-item>
          </b-breadcrumb>
        </b-row>
        <b-row>
          <b-container v-if="displayingType <= DISPLAYING_REPORTS" fluid>
            <b-row align-h="center">
              <h6 v-if="displayingType === DISPLAYING_CLUSTERS" class="project-title">
                <b-badge variant="primary" pill :style="badgeStyle"> My {{ displayedType }} Clusters </b-badge>
              </h6>
              <h6 v-else-if="displayingType === DISPLAYING_PROJECTS" class="project-title">
                <b-badge v-if="getNameCurrClusterNavigation" variant="primary" pill class="wrap-text" :style="badgeStyle"> Projects Under '{{ getNameCurrClusterNavigation }}' Cluster </b-badge>
              </h6>
              <h6 v-else class="project-title">
                <b-badge v-if="getNameCurrProjectNavigation" variant="primary" pill class="wrap-text" :style="badgeStyle"> Reports Under '{{ getNameCurrProjectNavigation }}' Project </b-badge>
              </h6>
            </b-row>
            <b-row class="justify-content-start">
              <b-col class="m-0 p-0">
                <b-button-group v-if="displayingType === DISPLAYING_CLUSTERS" class="bordered-button-group">
                  <b-button v-b-tooltip.hover.bottom="`Active Clusters`" size="sm" variant="primary" class="mr-2 p-1 btn-common" @click="updateShowedElements(false, 'Active')">
                    <b-icon :icon="activeClustersHoverActive ? 'star-fill' : 'star'" aria-label="Clusters List" />
                  </b-button>
                  <b-button v-b-tooltip.hover.bottom="`Favourite Clusters`" size="sm" variant="primary" class="mr-2 p-1 btn-common" @click="updateShowedElements(false, 'Favourite')">
                    <b-icon :icon="favouriteClustersHoverActive ? 'heart-fill' : 'heart'" aria-label="Favourite Clusters" />
                  </b-button>
                  <b-button v-b-tooltip.hover.bottom="`Archived Clusters`" size="sm" variant="primary" class="mr-2 p-1 btn-common" @click="updateShowedElements(false, 'Archived')">
                    <b-icon :icon="archivedClustersHoverActive ? 'folder-fill' : 'folder'" aria-label="Archived Clusters" />
                  </b-button>
                  <b-button v-b-tooltip.hover.bottom="`All Clusters`" size="sm" variant="primary" class="p-1 btn-common" @click="updateShowedElements(false, 'All')">
                    <b-icon :icon="allClustersHoverActive ? 'grid-fill' : 'grid'" aria-label="All Clusters" />
                  </b-button>
                </b-button-group>
                <span v-if="displayingType === DISPLAYING_CLUSTERS"> | </span>
                <b-button-group class="bordered-button-group">
                  <b-button
                    v-if="isAllowEditNavigation"
                    v-b-hover="handleAddHover"
                    v-b-tooltip.hover.bottom="`Add ${displayinTypeText}`"
                    size="sm"
                    variant="success"
                    class="mx-2 p-1 btn-common"
                    @mouseover="onHover(`Navigation/add${displayinTypeText}`)"
                    @mouseleave="onLeave"
                    @click="addValue"
                  >
                    <b-icon v-if="hoverAdd" aria-label="Add Value" icon="plus-square-fill" />
                    <b-icon v-else aria-label="Add Value" icon="plus-square" />
                  </b-button>
                  <b-button
                    v-if="displayingType === DISPLAYING_REPORTS && isAllowEditNavigation"
                    v-b-hover="handleAddHypelinkHover"
                    v-b-tooltip.hover.bottom="'Hyperlink report'"
                    size="sm"
                    variant="outline-success"
                    class="mx-2 p-1 btn-common"
                    @mouseover="onHover(`Navigation/hyperlinkReport`)"
                    @mouseleave="onLeave"
                    @click="addHyperinkReport"
                  >
                    <b-icon v-if="hoverAddHypelink" aria-label="Add Value" icon="folder-symlink-fill" />
                    <b-icon v-else aria-label="Add Value" icon="folder-symlink" />
                  </b-button>
                  <b-button
                    v-if="isAllowEditNavigation && isSingleSelectedNavigation && isOwnerOfSelected"
                    v-b-hover="handleEditHover"
                    v-b-tooltip.hover.bottom="`Edit ${displayinTypeText}`"
                    size="sm"
                    class="mx-2 p-1 btn-common btn-secondary"
                    @mouseover="onHover(`Navigation/edit${displayinTypeText}`)"
                    @mouseleave="onLeave"
                    @click="editValue"
                  >
                    <b-icon v-if="hoverEdit" aria-label="Edit Value" icon="pencil-fill" />
                    <b-icon v-else aria-label="Edit Value" icon="pencil" />
                  </b-button>
                  <b-button
                    v-if="isAllowEditNavigation && isSelectedNavigation && isOwnerOfSelected && displayingType === DISPLAYING_REPORTS"
                    v-b-hover="handleDeleteHover"
                    v-b-tooltip.hover.bottom="'Remove Selected'"
                    size="sm"
                    variant="danger"
                    class="mx-2 p-1 btn-common"
                    @click="deleteSelected"
                    @mouseover="onHover(`Navigation/remove${displayinTypeText}s`)"
                    @mouseleave="onLeave"
                  >
                    <b-icon v-if="hoverDelete" aria-label="Delete Selected" icon="x-square-fill" />
                    <b-icon v-else aria-label="Delete Selected" icon="x-square" />
                  </b-button>
                  <b-button
                    v-if="isAllowEditNavigation && allowOpting && isSingleSelectedNavigation && displayingType === DISPLAYING_CLUSTERS"
                    v-b-tooltip.hover.bottom="'Opt out'"
                    size="sm"
                    variant="info"
                    class="p-1 mx-2 btn-danger"
                    @click="optOutSharedCluster"
                    @mouseover="handleSharedClusterOptOutHover(true)"
                    @mouseleave="handleSharedClusterOptOutHover(false)"
                  >
                    <b-icon :icon="optOutSharedClusterHoverActive ? 'node-minus-fill' : 'node-minus'" aria-label="Opt Out" />
                  </b-button>
                  <b-button
                    v-if="isAllowEditNavigation && isOwnerOfSelected && isSingleSelectedNavigation && (displayingType === DISPLAYING_CLUSTERS || displayingType === DISPLAYING_REPORTS)"
                    v-b-tooltip.hover.bottom="`Share ${displayinTypeText}`"
                    size="sm"
                    variant="warning"
                    class="p-1 compare-btn mx-2 btn-common"
                    @click="shareElement"
                    @mouseover="onHover(`Navigation/share${displayinTypeText}`)"
                    @mouseleave="onLeave"
                  >
                    <b-icon aria-label="Share Selected" icon="share-fill" />
                  </b-button>
                  <b-button
                    v-if="displayingType === DISPLAYING_REPORTS && isAllowEditNavigation && isMultiSelectedNavigation"
                    v-b-tooltip.hover.bottom="'Compare Selected'"
                    size="sm"
                    variant="info"
                    class="p-1 compare-btn mx-2 btn-common"
                    @click="compareSelected"
                    @mouseover="onHover('Navigation/compareReports')"
                    @mouseleave="onLeave"
                  >
                    <b-icon aria-label="Compare Selected" icon="bezier2" />
                  </b-button>
                  <b-button
                    v-if="displayingType === DISPLAYING_REPORTS && isAllowEditNavigation && isSelectedNavigation"
                    v-b-tooltip.hover.bottom="'Connect reports data'"
                    size="sm"
                    variant="light"
                    class="p-1 compare-btn mx-2 btn-common"
                    @click="combineReports"
                    @mouseover="onHover('Navigation/combineReports')"
                    @mouseleave="onLeave"
                  >
                    <b-icon aria-label="Compare Selected" icon="collection-fill" />
                  </b-button>
                </b-button-group>
                <b-button-group v-if="isAllowEditNavigation && isSingleSelectedNavigation && displayingType === DISPLAYING_CLUSTERS && (allowArchive || allowFavourite)" class="bordered-button-group">
                  <b-button
                    v-if="allowArchive"
                    v-b-tooltip.hover.bottom="archiveLabel"
                    size="sm"
                    variant="dark"
                    class="p-1 compare-btn mx-2 btn-common"
                    @click="manageClusterArchival"
                    @mouseover="handleArchiveHover(true)"
                    @mouseleave="handleArchiveHover(false)"
                  >
                    <b-icon v-if="archiveLabel === `Restore Archived`" :icon="hoverActive ? 'arrow-up-square' : 'arrow-up-square'" aria-label="Restore Archived" />
                    <b-icon v-else :icon="hoverActive ? 'archive-fill' : 'archive'" aria-label="Archive Cluster" />
                  </b-button>
                  <b-button
                    v-if="allowFavourite"
                    v-b-tooltip.hover.bottom="favouriteLabel"
                    size="sm"
                    variant="info"
                    class="p-1 mx-2 btn-common"
                    @click="manageClusterFavourites"
                    @mouseover="handleFavouritesHover(true)"
                    @mouseleave="handleFavouritesHover(false)"
                  >
                    <b-icon v-if="favouriteLabel === `Make Favourite`" :icon="favouritesClusterHoverActive ? 'heart-fill' : 'heart'" aria-label="Make Favourite" />
                    <b-icon v-else :icon="'heart-half'" aria-label="Make Unfavourite" />
                  </b-button>
                </b-button-group>
                <b-button-group class="bordered-button-group">
                  <b-button
                    v-if="displayingType === DISPLAYING_REPORTS && isAllowEditNavigation && isSelectedNavigation"
                    v-b-tooltip.hover.bottom="'Download Raw Files'"
                    size="sm"
                    variant="dark"
                    class="p-1 compare-btn mx-2 btn-reports"
                    @click="downloadRawFiles"
                    @mouseover="onHover('Navigation/downloadRawFiles')"
                    @mouseleave="onLeave"
                  >
                    <b-icon aria-label="Download Selected" icon="arrow-bar-down" />
                  </b-button>
                  <b-button
                    v-b-tooltip.hover.bottom="'Refresh'"
                    size="sm"
                    variant="outline-info"
                    class="p-1 refresh-btn mx-2"
                    @mouseover="onHover('Navigation/refreshTree')"
                    @mouseleave="onLeave"
                    @click.prevent="refresh"
                  >
                    <b-icon icon="arrow-repeat" aria-label="Update" />
                  </b-button>
                </b-button-group>
              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col class="col-4 mr-1">
                <b-form-input ref="searchInput" v-model="filterText" type="text" placeholder="Search..." />
              </b-col>
              <b-col class="col-2 ml-1">
                <b-form-select ref="pageSize" v-model="selectedPageSize" v-b-tooltip.hover.top="`Select Page Size`" :options="pageSizeOptions" placeholder="page size..." @change="onPageSizeChanged" />
              </b-col>
              <b-col class="col-2 ml-1">
                <b-form-select ref="gridTheme" v-model="selectedTheme" v-b-tooltip.hover.top="`Select Theme`" :options="themeOptions" placeholder="select theme..." @change="onThemeChanged" />
              </b-col>
            </b-row>
          </b-container>
          <div v-else class="welcome-mssg">
            <h4 class="header-welcome">Welcome to djuli {{ getDisplayNameMiddlewareAuth }}</h4>
            <p>Please go to the Navigation section to open a report or open a report from the left</p>
            <img class="djuliLogo-mssg" alt="djuliLogo" src="../assets/MainMenu/djuliImage.png" />
          </div>
        </b-row>
      </b-container>
      <div :class="['ag-grid-container', agGridTheme]">
        <ag-grid-vue
          v-if="displayingType === DISPLAYING_REPORTS && columnReportDefs !== null && projectState === 0"
          ref="agGridReport"
          style="width: 100%; height: 100%"
          :default-col-def="defaultColDef"
          :column-defs="columnReportDefs"
          :row-data="tableItems"
          :grid-options="gridOptions"
          :pagination-number-formatter="paginationNumberFormatter"
          :row-style="rowStyle"
          :get-row-class="getRowClass"
          @grid-ready="onGridReady"
          @rowClicked="onReportsRowClickedAgGrid"
          @selectionChanged="onCheckboxValueChanged"
          @first-data-rendered="onFirstDataRendered"
        />
        <ag-grid-vue
          v-else-if="displayingType !== DISPLAYING_REPORTS && currentColumnDefs !== null && (displayingType === DISPLAYING_PROJECTS ? clusterState === 0 : true)"
          ref="agGrid"
          style="width: 100%; height: 100%"
          :default-col-def="defaultColDef"
          :column-defs="currentColumnDefs"
          :row-data="tableItems"
          :grid-options="gridOptions"
          :pagination-number-formatter="paginationNumberFormatter"
          :row-style="rowStyle"
          :get-row-class="getRowClass"
          @grid-ready="onGridReady"
          @rowClicked="onRowClickedAgGrid"
          @selectionChanged="onCheckboxValueChanged"
          @first-data-rendered="onFirstDataRendered"
        />
      </div>
    </template>
    <ShareWindow class="sharing-window" @closed="onSharingWindowClose" />
  </div>
</template>
<script>
import ShareWindow from '../components/navigation/ShareWindow';
import { mapGetters, mapActions } from 'vuex';
import { AgGridVue } from 'ag-grid-vue';
import ReportInfo from '@/functions/ReportInfo.js';
import { IdentifierComparison, IconIncompleteReport, IconSharing, homogenizeReport } from '@/common/sharedDefinitions/reportDefinitions';
import { AES } from 'crypto-js';
import Utf8 from 'crypto-js/enc-utf8';
import { getAuth } from 'firebase/auth';
import { firebaseApp } from '@/firebaseConfig';
import clusterArchivalOperation from '@/functions/clusterArchivalOperation';
import custerFavouriteOperation from '@/functions/clusterFavouritesOperation';
import sharedClusterOptingOperation from '@/functions/sharedClusterOptingOperation';
import clusterUtils from '@/functions/clusterUtils';
const DISPLAYING_CLUSTERS = 0;
const DISPLAYING_PROJECTS = 1;
const DISPLAYING_REPORTS = 2;
const auth = getAuth(firebaseApp);
//States
const CLUSTER_STATE = 0;
const CLUSTER_NO_PERMISSION = 1;
const CLUSTER_NOT_EXISTS = 2;
const PROJECT_STATE = 0;
const PROJECT_NO_PERMISSION = 1;
const PROJECT_NOT_EXISTS = 2;

const notifyZone = 'Navigation';
const reNumber = RegExp('\\d+');
export default {
  name: notifyZone,
  components: {
    ShareWindow,
    AgGridVue,
  },
  data() {
    return {
      clusterState: CLUSTER_STATE,
      projectState: PROJECT_STATE,
      hoverDelete: false,
      hoverAdd: false,
      hoverAddHypelink: false,
      hoverEdit: false,
      hoverActive: false,
      activeClustersHoverActive: false,
      favouriteClustersHoverActive: false,
      archivedClustersHoverActive: false,
      allClustersHoverActive: false,
      favouritesClusterHoverActive: false,
      optOutSharedClusterHoverActive: false,
      displayedType: '',
      isOwnerOfSelected: false,
      allowArchive: false,
      allowFavourite: false,
      allowOpting: false,
      headerBgVariant: 'light',
      showingPopup: false,
      emailValid: true,
      resourceType: 'Cluster',
      messageBody: '',
      selectedRecord: {
        clusterId: '',
        projectId: '',
        reportId: '',
        oldName: '',
        rowIndex: null,
      },
      cardSizeClass: 'large-card',
      isOwned: false,
      isArchived: false,
      archiveLabel: 'Archive Selected',
      favouriteLabel: '',
      reportsAccess: null,
      tableItems: [],
      favouriteItemsSorted: [],
      tableFields: [],
      routeList: [],
      totalClusters: 0,
      totalProjects: 0,
      totalReports: 0,
      totalClustersOwned: 0,
      totalClustersShared: 0,
      totalProjectsShared: 0,
      totalProjectsOwned: 0,
      clusterOwnedBy: '',
      projectOwnedBy: '',
      totalOwnedClusters: [],
      totalOwnedProjects: [],
      totalOwnedReports: [],
      clusterOwnership: '',
      projectOwnership: '',
      dictIdReports: {},
      displayingType: -1,
      displayinTypeText: '',
      isLoading: false,
      isSearchFocused: false,
      isComparedBtnShown: false,
      DISPLAYING_CLUSTERS,
      DISPLAYING_PROJECTS,
      DISPLAYING_REPORTS,
      resourceItems: ['Cluster', 'Project'],
      receiver: '',
      routeClusterId: '',
      routeProjectId: '',
      breadCrumbActive: false,
      rowData: null,
      selectedRows: [],
      gridApi: null,
      selectedPageSize: 10,
      isAbove500px: true,
      paginationNumberFormatter: null,
      agGridTheme: 'ag-theme-alpine',
      selectedTheme: 'ag-theme-alpine',
      filterText: '',
      rowStyle: { cursor: 'pointer' },
      defaultColDef: {
        editable: false,
        resizable: true,
        filter: true,
        flex: 1,
      },
      badgeStyle: {
        fontSize: '16px', // Default font size
      },
      gridOptions: {
        rowSelection: 'multiple',
        isRowSelectable: (params) => {
          return params.data.disable !== true;
        },
        suppressRowClickSelection: true, // Rows won't be selected when clicked
        pagination: true,
        paginationPageSize: 10,
        domLayout: 'autoHeight',
        rowBuffer: 10,
        suppressHorizontalScroll: false,
        suppressNoRowsOverlay: true, // Hide the "No Rows" overlay
        suppressLoadingOverlay: true, // Hide the loading overlay
      },
      // The options for the page size selector input
      pageSizeOptions: [
        { value: 10, text: 'page size...' },
        { value: 5, text: '5' },
        { value: 10, text: '10' },
        { value: 20, text: '20' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
        { value: 100000, text: 'All' },
      ],
      themeOptions: [
        { value: 'ag-theme-alpine', text: 'select theme...' },
        { value: 'ag-theme-alpine', text: 'Alpine(Default)' },
        { value: 'ag-theme-blue', text: 'Blue' },
        { value: 'ag-theme-dark', text: 'Dark' },
      ],
      // Columns definition for the cluster tables
      columnClusterDefs: [
        {
          headerName: ' ',
          field: 'checkbox',
          suppressSizeToFit: true,
          checkboxSelection: true,
          headerCheckboxSelection: true,
          maxWidth: 50,
          sortable: false,
          filter: false,
          flex: 1,
        },
        {
          headerName: 'ID',
          field: 'Id',
          maxWidth: 80,
          filter: false,
          flex: 1,
          suppressMovable: true,
        },
        {
          headerName: 'Cluster Name',
          field: 'Name',
          minWidth: 300,
          autoHeight: true,
          wrapText: true,
          flex: 1,
          suppressMovable: true,
        },
        {
          headerName: 'Ownership',
          field: 'Ownership',
          flex: 1,
          suppressMovable: true,
        },
      ],
      // Columns definition for the  projects tables
      columnProjectDefs: [
        {
          headerName: ' ',
          field: 'checkbox',
          suppressSizeToFit: true,
          checkboxSelection: true,
          headerCheckboxSelection: true,
          maxWidth: 50,
          sortable: false,
          filter: false,
          flex: 1,
        },
        {
          headerName: 'ID',
          field: 'Id',
          maxWidth: 80,
          sort: 'asc',
          filter: false,
          flex: 1,
          suppressMovable: true,
        },
        {
          headerName: 'Project Name',
          field: 'Name',
          minWidth: 300,
          autoHeight: true,
          wrapText: true,
          flex: 1,
          suppressMovable: true,
        },
        {
          headerName: 'Ownership',
          field: 'Ownership',
          width: 100,
          flex: 1,
          suppressMovable: true,
        },
      ],
      // Columns definition for the reports table
      columnReportDefs: [
        {
          headerName: ' ',
          field: 'checkbox',
          suppressSizeToFit: true,
          checkboxSelection: true,
          headerCheckboxSelection: true,
          maxWidth: 50,
          sortable: false,
          filter: false,
          flex: 1,
        },
        {
          headerName: 'ID',
          field: 'id',
          maxWidth: 80,
          sort: 'dsc',
          filter: false,
          flex: 1,
          suppressMovable: true,
        },
        {
          headerName: 'Report Name',
          field: 'descriptiveId',
          minWidth: 300,
          autoHeight: true,
          wrapText: true,
          flex: 1,
          suppressMovable: true,
        },
        {
          headerName: 'Date',
          field: 'date',
          filter: false,
          flex: 1,
          suppressMovable: true,
        },
        {
          headerName: 'Batch Id',
          field: 'batchId',
          flex: 1,
          suppressMovable: true,
        },
        {
          headerName: 'Operator',
          field: 'operator',
          autoHeight: true,
          wrapText: true,
          flex: 1,
          suppressMovable: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'isMultiSelectedNavigation',
      'isSingleSelectedNavigation',
      'isSelectedNavigation',
      'getDisplayNameMiddlewareAuth',
      'isAllowEditNavigation',
      'getClusterDataMiddleware',
      'getProjectsClustMiddleware',
      'getReportsProjMiddleware',
      'getNameCurrClusterNavigation',
      'getCurrentClusterNavigation',
      'getCurrentProjectNavigation',
      'getNameCurrProjectNavigation',
      'getCurrentReportViewer',
      'getClusterSelectedObjNavigation',
      'getCurrentProjectListNavigation',
      'getSelectedClusterRecordData',
      'getSelectedProjectRecordData',
      'getSelectedReportRecordData',
      'getUserNameMiddlewareAuth',
      'getReportAccessTypeMiddleware',
    ]),
    currentColumnDefs() {
      // Return the appropriate column definitions based on the currentPageType
      return this.displayingType === DISPLAYING_CLUSTERS ? this.columnClusterDefs : this.columnProjectDefs;
    },
    updateCardSize() {
      // Add a CSS class based on the display size
      if (window.innerWidth < 768) {
        return 'small-card';
      } else if (window.innerWidth < 992) {
        return 'medium-card';
      } else {
        return 'large-card';
      }
    },
    breadcrumbClusterName() {
      if (!this.getNameCurrClusterNavigation) return 'Projects';
      const name = this.getNameCurrClusterNavigation;
      return name.length > 20 ? name.slice(0, 20) + '…' : name;
    },
    breadcrumbProjectName() {
      if (!this.getNameCurrProjectNavigation) return 'Reports';
      const name = this.getNameCurrProjectNavigation;
      return name.length > 20 ? name.slice(0, 20) + '…' : name;
    },
  },
  async mounted() {
    // Add the resize event listener when the component is mounted
    window.addEventListener('resize', this.handleResize);
    this.updateBadgeFontSize(); // Call the method on component mount
    window.addEventListener('resize', this.updateBadgeFontSize); // Listen for window resize
    // Check the window size initially
    this.handleResize();
    await this.updateShowedElements(false, this.displayedType, false);
  },
  created() {
    this.paginationNumberFormatter = (params) => {
      return '[' + params.value.toLocaleString() + ']';
    };
    this.$watch(
      async () => this.$route.params,
      async () => { await this.updateShowedElements(false, this.displayedType); },
    );
  },
  unmounted() {
    // Remove the resize event listener when the component is about to be unmounted
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('resize', this.updateBadgeFontSize); // Clean up event listener
  },
  watch: {
    filterText(newValue) {
      // Search for both clusters/projects grid and reports grid
      if (this.$refs.agGrid) {
        this.$refs.agGrid.gridOptions.api.setQuickFilter(newValue);
      }
      if (this.$refs.agGridReport) {
        this.$refs.agGridReport.gridOptions.api.setQuickFilter(newValue);
      }
    },
    currentColumnDefs(newDefs, oldDefs) {
      if (newDefs !== null && newDefs !== oldDefs && newDefs.length > 0) {
        this.$nextTick(() => {
          if (this.$refs.agGrid.api) this.$refs.agGrid.api.setColumnDefs(newDefs);
        });
      }
    },
    columnReportDefs(newDefs, oldDefs) {
      if (newDefs !== null && newDefs !== oldDefs && newDefs.length > 0) {
        this.$nextTick(() => {
          if (this.$refs.agGridReport.api) this.$refs.agGridReport.api.setColumnDefs(newDefs);
        });
      }
    },
    receiver(value) {
      if (value) {
        this.emailValid = true;
      }
    },
  },
  methods: {
    ...mapActions([
      'setForceUpdReprtsTableReportViewer',
      'setContextOnHover',
      'setConfigSharingWindow',
      'readClusterListMiddleware',
      'setCurrentClusterNavigation',
      'readClusterDataMiddleware',
      'setNameCurrClusterNavigation',
      'setCurrentProjectNavigation',
      'setNameCurrProjectNavigation',
      'setSelectedNavigation',
      'setAllowEditNavigation',
      'readReportsProjMiddleware',
      'setAllowEditReportViewer',
      'addMessageTerminalSection',
      'addReportMiddleware',
      'removeReportMiddleware',
      'addComparisonReportMiddleware',
      'setDragModeReportViewer',
      'setToolSideBarVisibleReportViewer',
      'readClusterListMiddleware',
      'addClusterMiddleware',
      'addProjectMiddleware',
      'setClusterSelectedObjNavigation',
      'setLoadingClustProyNavigation',
      'resetCurrentClusterNavigation',
      'editProjectMiddleware',
      'editClusterMiddleware',
      'setSelectedClusterRecordData',
      'setSelectedProjectRecordData',
      'setSelectedReportRecordData',
      'downloadRawFilesMiddleware',
      'setReportsProjMiddleware',
      'readClusterOwnerDataMiddleware',
      'readUserFullNameMiddlewareAuth',
      'sendResourceAccessRequestMiddleware',
      'manageClusterArchivalMiddleware',
      'setConfigReportModifiedReportViewer',
      'setAutoSaveReportViewer',
      'addHyperlinkReportMiddleware',
      'readSingleReportMiddleware',
      'updateReportMiddleware',
    ]),
    onGridReady(params) {
      this.gridApi = params.Api;
    },
    async onCheckboxValueChanged(event) {
      this.selectedRows = event.api.getSelectedNodes();
      await this.setSelectedNavigation(this.selectedRows.length);
      this.isOwnerOfSelected = this.selectedRows[0]?.data.owned;
      this.allowArchive = false;
      this.allowFavourite = false;
      this.allowOpting = false;

      if (this.displayingType === DISPLAYING_CLUSTERS && this.selectedRows !== 'undefined') {
        this.selectedRecord.clusterId = this.selectedRows[0]?.data.uid ? this.selectedRows[0]?.data.uid : '';
        this.selectedRecord.projectId = '';
        this.selectedRecord.reportId = '';
        this.selectedRecord.oldName = this.selectedRows[0]?.data.Name ? this.selectedRows[0]?.data.Name : '';
        this.selectedRecord.rowIndex = this.selectedRows[0]?.data.id ? this.selectedRows[0]?.data.id - 1 : null;
        this.allowFavourite = true;

        if (this.selectedRows[0]?.data.owned) {
          this.allowArchive = true;
        } else {
          this.allowOpting = true;
        }

        if (this.selectedRows[0]?.data.isArchived) {
          this.archiveLabel = 'Restore Archived';
        } else {
          this.archiveLabel = 'Archive Selected';
        }

        if (this.selectedRows[0]?.data.isFavourite) {
          this.favouriteLabel = 'Make Unfavourite';
        } else {
          this.favouriteLabel = 'Make Favourite';
        }
      } else if (this.displayingType === DISPLAYING_PROJECTS && this.selectedRows !== 'undefined') {
        this.selectedRecord.clusterId = '';
        this.selectedRecord.projectId = this.selectedRows[0]?.data.uid ? this.selectedRows[0]?.data.uid : '';
        this.selectedRecord.reportId = '';
        this.selectedRecord.oldName = this.selectedRows[0]?.data.Name ? this.selectedRows[0]?.data.Name : '';
        this.selectedRecord.rowIndex = this.selectedRows[0]?.data.id ? this.selectedRows[0]?.data.id - 1 : null;
      } else if (this.displayingType === DISPLAYING_REPORTS && this.selectedRows !== 'undefined') {
        this.selectedRecord.clusterId = this.getCurrentClusterNavigation;
        this.selectedRecord.projectId = this.getCurrentProjectNavigation;
        this.selectedRecord.reportId = this.selectedRows[0]?.data.uid ? this.selectedRows[0]?.data.uid : '';
        this.selectedRecord.oldName = this.selectedRows[0]?.data.descriptiveId ? this.selectedRows[0]?.data.descriptiveId : '';
        this.selectedRecord.rowIndex = this.selectedRows[0]?.data.id ? this.selectedRows[0]?.data.id - 1 : null;
      }
    },
    handleResize() {
      // Update the isAbove500px flag based on the window size
      this.isAbove500px = window.innerWidth > 500;
      this.cardSizeClass = this.updateCardSize;
    },
    updateBadgeFontSize() {
      // Adjust font size based on screen width
      if (window.innerWidth <= 768) {
        this.badgeStyle.fontSize = '55%'; // Adjust font size for smaller screens
      } else {
        this.badgeStyle.fontSize = '75%'; // Default font size
      }
    },
    onFirstDataRendered(params) {
      this.gridApi = params.api;
    },
    onPageSizeChanged() {
      var value = this.selectedPageSize;
      this.gridApi.paginationSetPageSize(Number(value));
    },
    onThemeChanged() {
      this.agGridTheme = this.selectedTheme;
    },
    onHover(route) {
      this.setContextOnHover(route);
    },
    onLeave() {
      this.setContextOnHover(null);
    },
    handleDeleteHover(hovered) {
      //Handle the hover on the delete button
      this.hoverDelete = hovered;
    },
    handleAddHover(hovered) {
      //Handle the hover on the Add button
      this.hoverAdd = hovered;
    },
    handleAddHypelinkHover(hovered) {
      //Handle the hover on the Add button
      this.hoverAddHypelink = hovered;
    },
    handleEditHover(hovered) {
      //Handle the hover on the edit button
      this.hoverEdit = hovered;
    },
    handleArchiveHover(isHovered) {
      //Handle the hover on the archive button
      this.hoverActive = isHovered;
    },
    handleFavouritesHover(isHovered) {
      //Handle the hover on show favourites button
      this.favouritesClusterHoverActive = isHovered;
    },
    handleSharedClusterOptOutHover(isHovered) {
      //Handle the hover on opt out shared clusters button
      this.optOutSharedClusterHoverActive = isHovered;
    },
    async refresh() {
      if (this.displayingType === DISPLAYING_REPORTS) {
        await this.setReportsTable(true);
      } else {
        this.resetCurrentClusterNavigation();
        if (this.$refs.agGrid.api) {
          this.$refs.agGrid.api.setColumnDefs(this.currentColumnDefs);
        }
        if (this.$refs.agGridReport) {
          this.$refs.agGridReport.api.setColumnDefs(this.currentColumnDefs);
        }
        await this.updateShowedElements(true, this.displayedType);
        if (this.$route.params.clusterId) {
          this.setCurrentClusterNavigation(this.$route.params.clusterId);
        }
        if (this.$route.params.projectId) {
          this.setCurrentProjectNavigation(this.$route.params.projectId);
        }
      }
    },
    async getCurrentClusterInfo(clusterId, forceUpdate = false) {
      if (forceUpdate || this.getProjectsClustMiddleware === null || this.getProjectsClustMiddleware.clusterId !== clusterId) {
        const responseData = await this.readClusterDataMiddleware({clusterId: clusterId});
        if (!responseData.data.clusterId) {
          this.clusterState = CLUSTER_NOT_EXISTS;
        } else if (responseData.success) {
          this.clusterState = CLUSTER_STATE;
        } else {
          this.clusterState = CLUSTER_NO_PERMISSION;
        }
      }
      const clusterName = this.getProjectsClustMiddleware.clusterName || `Cluster ${clusterId}`;
      this.setNameCurrClusterNavigation(clusterName);
      return true;
    },
    async updateShowedElements(forceUpdate, displayedType, clenSelection = true) {
      const routeIds = typeof this.$route.params.selection !== 'undefined' ? this.$route.params.selection.split('/') : [];
      // Reset common variables
      if (clenSelection || this.displayingType !== routeIds.length) {
        this.setSelectedNavigation(0);
        this.filterText = '';
        this.tableItems = [];
      }
      this.displayingType = routeIds.length;
      if (this.displayingType > DISPLAYING_REPORTS) {
        return;
      }
      this.routeList = routeIds;
      // Set default value if Cluster is visible
      if (this.displayingType > DISPLAYING_CLUSTERS && !this.getCurrentClusterNavigation) {
        const clusterId = routeIds[0];
        this.setCurrentClusterNavigation(clusterId);
        this.setNameCurrClusterNavigation(`Cluster(${clusterId})`);
      }

      if (this.displayingType > DISPLAYING_PROJECTS && !this.getCurrentProjectNavigation) {
        const projectId = routeIds[1];
        this.setCurrentProjectNavigation(projectId);
        this.setNameCurrProjectNavigation(`Project(${projectId})`);
      }

      try {
        this.isLoading = true;
        if (forceUpdate || this.getClusterDataMiddleware === null) {
          const success = await this.readClusterListMiddleware();
          if (!success) {
            return;
          }
        }
      } catch (error) {
        const errText = 'Error retrieving the clusters from the server, please try in a few minutes.';
        const errTitle = 'Conection failed';
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
      } finally {
        this.isLoading = false;
      }

      if (this.displayingType === DISPLAYING_CLUSTERS) {
        this.setAllowEditNavigation(true);
        this.displayinTypeText = 'Cluster';
        this.mainTitle = 'My Clusters';

        //To increase the Ids of each object of Table Items by 1 because index starts from 0
        let listItems = this.getClusterDataMiddleware.clusterList;
        listItems.forEach((obj, index) => { obj.Id = index + 1; });
        // Filter the items which are not archived
        const filteredItems = listItems.filter((obj) => !obj.isArchived);
        const archivedItems = listItems.filter((obj) => obj.isArchived);
        const favouriteItems = listItems.filter((obj) => obj.isFavourite);
        this.activeClustersHoverActive = false;
        this.favouriteClustersHoverActive = false;
        this.allClustersHoverActive = false;
        this.archivedClustersHoverActive = false;
        if (displayedType === '') {
          // By default if the user has favorites then we display favorites cluster, otherwise active
          displayedType = favouriteItems.length > 0 ? 'Favourite' : 'Active';
        }
        if (displayedType === 'Archived') {
          this.archivedClustersHoverActive = true;
          this.displayedType = 'Archived';
          this.tableItems = archivedItems;
        } else if (displayedType === 'Favourite') {
          this.favouriteClustersHoverActive = true;
          this.displayedType = 'Favourite';
          this.favouriteItemsSorted = favouriteItems.slice().sort((a, b) => {
            //Sorting from newest to oldest
            return new Date(b.favouriteRank).getTime() - new Date(a.favouriteRank).getTime();
          });
          this.tableItems = this.favouriteItemsSorted;
        } else if (displayedType === 'Active') {
          this.activeClustersHoverActive = true;
          this.displayedType = 'Active';
          this.tableItems = filteredItems;
        } else {
          this.displayedType = 'All';
          this.tableItems = listItems;
          this.allClustersHoverActive = true;
        }
        // Attach the user display name if the cluster name is duplicate
        this.tableItems = await clusterUtils.attachUserToDuplicateCluster(this.tableItems);
        this.totalClusters = listItems.length;
        this.totalClustersShared = listItems.filter((item) => item.Ownership === 'Shared').length;
        this.totalClustersOwned = listItems.filter((item) => item.Ownership === 'Owned').length;
      } else if (this.displayingType === DISPLAYING_PROJECTS) {
        this.displayinTypeText = 'Project';
        this.isLoading = true;
        const clusterId = routeIds[0];
        this.mainTitle = this.getNameCurrClusterNavigation;
        try {
          await this.getCurrentClusterInfo(clusterId, forceUpdate);
          this.setAllowEditNavigation(this.getProjectsClustMiddleware.accessType);
          const projectRaw = this.getProjectsClustMiddleware.projects.sort((a, b) => (a.projectName > b.projectName ? 1 : -1));
          this.setClusterSelectedObjNavigation(this.getProjectsClustMiddleware);
          const projectList = [];
          for (let j = 0; j < projectRaw.length; j++)
            projectList.push({
              Id: j,
              Name: projectRaw[j].projectName,
              Ownership: projectRaw[j].owned ? 'Owned' : 'Shared',
              ownedByName: projectRaw[j].ownedByName,
              uid: projectRaw[j].projectId,
              owned: projectRaw[j].owned,
              clusterId: clusterId,
              accessType: projectRaw[j].accesstype || false,
              disable: projectRaw[j].disable || false,
            });
          //To increase the Ids of each object of Table Items by 1 because index starts from 0
          let listItems = projectList;
          listItems.forEach((obj, index) => { obj.Id = index + 1; });
          this.tableItems = listItems;
          this.totalProjects = listItems.length;
          this.totalProjectsShared = listItems.filter((item) => item.Ownership === 'Shared').length;
          this.totalProjectsOwned = listItems.filter((item) => item.Ownership === 'Owned').length;
          if (forceUpdate || this.getClusterDataMiddleware === null) {
            const success = await this.readClusterListMiddleware();
            if (!success) {
              return;
            }
          }
          this.setSelectedClusterRecordData(this.getClusterDataMiddleware.clusterList.find((obj) => obj.uid === clusterId));
          this.clusterOwnership = this.getSelectedClusterRecordData.Ownership;
          this.clusterOwnedBy = this.getSelectedClusterRecordData.ownedByName;
        } catch (error) {
          const errText = 'Error retrieving the projects from the server, please try in a few minutes.';
          const errTitle = 'Conection failed';
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
        } finally {
          this.isLoading = false;
        }
      } else {
        this.displayinTypeText = 'Report';
        await this.setReportsTable(forceUpdate);
      }
      // If cluster is visible, then it just retrieve the information on background if needed
      if (this.displayingType > DISPLAYING_CLUSTERS) this.getCurrentClusterInfo(routeIds[0]);
    },
    async downloadRawFiles() {
      const selectedReports = this.gridApi.getSelectedNodes();
      const confirmMany = selectedReports.length > 25;
      let confirmMessage = 'Do you want to download the raw files of ';
      confirmMessage += selectedReports.length > 1 ? `${selectedReports.length} reports?` : `report '${selectedReports[0].data.descriptiveId}'?`;
      if (confirmMany) confirmMessage += ' This might take a while';
      try {
        await this.$confirm(confirmMessage, confirmMany ? 'Warning' : 'Confirmation', confirmMany ? 'warning' : 'question', {
          confirmButtonText: 'Download',
        });
      } catch {
        return;
      }
      try {
        const failedReports = [];
        if (selectedReports.length > 1) {
          const infoTitle = 'Raw Files Extraction';
          const infoText = 'Starting download...';
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.INFO, infoTitle, infoText, notifyZone);
        }
        for (let i = 0; i < selectedReports.length; i++) {
          const selReport = selectedReports[i];
          const success = await this.downloadRawFilesMiddleware({
            projectId: this.getCurrentProjectNavigation,
            reportId: selReport.data.uid,
            clusterId: this.getCurrentClusterNavigation,
          });
          if (success) {
            const infoTitle = 'Files downloaded';
            const infoText = `Report: ${selReport.data.descriptiveId}`;
            this.$notifTerm.addNotification(this.$notifTerm.typesNotif.INFO, infoTitle, infoText, notifyZone);
          } else {
            const errTitle = 'Donwload Failed';
            const errText = `Report: ${selReport.data.descriptiveId}`;
            this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
            failedReports.push(selReport.data.descriptiveId);
          }
        }
        if (failedReports.length > 0) {
          this.$alert(`Failing reports: ${failedReports.join(', ')}`, 'Incomplete reports', 'error');
        } else if (selectedReports.length > 1) {
          const successTitle = 'Raw Files Extraction';
          const successText = 'Done.';
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.SUCCESS, successTitle, successText, notifyZone);
        }
      } catch {
        const errTitle = 'Donwload Failed';
        const errText = 'Failed to download. Please check your internet connection';
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
      }
    },
    // setReportsTable is used to populate the list of reports in a specific project of a given cluster
    async setReportsTable(forceUpdate = false) {
      if (this.getCurrentProjectNavigation === '' || typeof this.getCurrentProjectNavigation === 'undefined') {
        return;
      }
      this.isLoading = true;
      try {
        if (this.getReportsProjMiddleware === null || this.getReportsProjMiddleware.projectId !== this.getCurrentProjectNavigation || forceUpdate) {
          this.filterText = '';
          if (this.getClusterDataMiddleware === null) {
            await this.readClusterListMiddleware();
          }
          const responseData = await this.readReportsProjMiddleware({
            projectId: this.getCurrentProjectNavigation,
            clusterId: this.getCurrentClusterNavigation,
          });
          if (!responseData.data?.projectId) {
            this.projectState = PROJECT_NOT_EXISTS;
            return;
          } else if (responseData.success) {
            this.projectState = PROJECT_STATE;
          } else {
            this.projectState = PROJECT_NO_PERMISSION;
            return;
          }
        }
        this.setSelectedNavigation(0);
        //const reportsProjArr = this.getReportsProjMiddleware.reports.sort((a, b) => (a.dateLastUpdate ? a.dateLastUpdate : a.createdAt) > (b.dateLastUpdate ? b.dateLastUpdate : b.createdAt) ? 1 : -1);
        const reportsProjArr = this.getReportsProjMiddleware.reports.sort((a, b) => (parseInt(reNumber.exec(a.shortId.toString())[0]) > parseInt(reNumber.exec(b.shortId.toString())[0]) ? -1 : 1));
        const newDataTable = [];
        this.dictIdReports = {};
        for (let j = 0; j < reportsProjArr.length; j++) {
          const uncomplete = ReportInfo.isReportUncomplete(this, reportsProjArr[j]);
          let reportName = reportsProjArr[j].name;
          reportsProjArr[j].internalCounter = parseInt(reNumber.exec(reportsProjArr[j].shortId.toString())[0]);
          // reportsProjArr[j].internalCounter = reportsProjArr.length - j
          if (uncomplete) {
            reportName = `${IconIncompleteReport}  ${reportName}`;
          }
          if (typeof reportsProjArr[j].shareCount !== 'undefined' && reportsProjArr[j].shareCount > 0) {
            reportName = `${IconSharing}  ${reportName}`;
          }
          newDataTable.push({
            id: parseInt(reNumber.exec(reportsProjArr[j].shortId.toString())[0]),
            descriptiveId: reportName,
            date: reportsProjArr[j].dateTest ? reportsProjArr[j].dateTest : reportsProjArr[j].dateLastUpdate ? reportsProjArr[j].dateLastUpdate : reportsProjArr[j].createdAt,
            batchID: reportsProjArr[j].sensorBatchId,
            operator: reportsProjArr[j].operator,
            uid: reportsProjArr[j].reportId,
            internalCounter: reportsProjArr[j].internalCounter,
            owned: reportsProjArr[j].owned,
            accessType: reportsProjArr[j].accessType,
            disable: reportsProjArr[j].disable || false,
            linkProjectId: reportsProjArr[j].linkProjectId || '',
            linkReportId: reportsProjArr[j].linkReportId || '',
            linkClusterId: reportsProjArr[j].linkClusterId || '',
          });
          this.dictIdReports[reportsProjArr[j].internalCounter] = reportsProjArr[j];
        }
        this.tableItems = newDataTable;
        this.totalReports = newDataTable.length;
        this.projectOwnedBy = this.getReportsProjMiddleware.ownedByName;
        await this.getCurrentClusterInfo(this.getCurrentClusterNavigation, forceUpdate);
        // To read the projects data for the summary of reports info card
        const projectRaw = this.getProjectsClustMiddleware.projects.sort((a, b) => (a.projectName > b.projectName ? 1 : -1));
        this.setClusterSelectedObjNavigation(this.getProjectsClustMiddleware);
        this.setSelectedProjectRecordData(projectRaw[0]);
        this.projectOwnership = this.getSelectedProjectRecordData.Ownership;
      } catch {
        const errTitle = 'Error';
        const errText = 'Error while updating report table';
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
      } finally {
        this.isLoading = false;
      }
    },
    onSharingWindowClose(type) {
      if (type === 'cluster') {
        this.refresh();
      } else if (type === 'report') {
        // this.$refs.TableReports.setTable(true) // this is for the old table
        this.setReportsTable(true); // this is for the ag-grid-vue
      }
    },

    async compareSelected() {
      this.setForceUpdReprtsTableReportViewer(true);
      this.isLoading = true;
      this.selectedRows = this.gridApi.getSelectedNodes();
      const reportsComparing = [];
      for (let j = 0; j < this.selectedRows.length; j++) {
        const shortIdComp = String(this.selectedRows[j].data.shortId);
        const internalCounter = this.selectedRows[j].data.internalCounter;
        if (shortIdComp.includes(IdentifierComparison)) {
          const errTitle = 'Error creating the comparative report';
          const errText = 'It is not possible to compare comparative reports';
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
          this.isLoading = false;
          return;
        }
        reportsComparing.push({id: this.dictIdReports[internalCounter].reportId});
      }
      const idDBReport = await this.addComparisonReportMiddleware({
        //Create comparison report
        clusterId: this.getCurrentClusterNavigation,
        projectId: this.getCurrentProjectNavigation,
        report_name: `New comparison report ${this.getNameCurrProjectNavigation}`,
        comparing: reportsComparing,
      });
      if (idDBReport === null) {
        const errTitle = 'Error creating the report';
        const errText = 'Error connecting with the server. Please try again in a few minutes.';
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
        this.isLoading = false;
        return;
      }
      this.isLoading = false;
      this.setDragModeReportViewer(true);
      this.setToolSideBarVisibleReportViewer(false);
      this.setAllowEditReportViewer(true);
      this.$router.push({
        name: 'ReportViewer',
        params: {
          projectId: this.getCurrentProjectNavigation,
          reportId: idDBReport,
          clusterId: this.getCurrentClusterNavigation,
        },
      });
    },
    // Maange archival/unarchival of a selected cluster
    async manageClusterArchival() {
      this.isArchived = !this.selectedRows[0]?.data.isArchived;
      await clusterArchivalOperation.archiveOrRestoreCluster(this, this.selectedRecord.clusterId, this.isArchived, notifyZone);
    },
    // Maange archival/unarchival of a selected cluster
    async manageClusterFavourites() {
      this.isFavourite = !this.selectedRows[0]?.data.isFavourite;
      await custerFavouriteOperation.favourOrUnfavourCluster(this, this.selectedRecord.clusterId, this.isFavourite, notifyZone);
    },
    async optOutSharedCluster() {
      await sharedClusterOptingOperation.optOut(this, this.selectedRecord.clusterId, notifyZone);
    },
    async onRowClickedAgGrid(params) {
      const disabledReport = params.data.disable || false;
      if (disabledReport) {
        await this.$alert(
          'Exciting Premium content awaits! Please take a moment to verify your subscription',
          `Premium ${this.displayingType === DISPLAYING_CLUSTERS ? 'Cluster' : 'Project'}`,
          'info',
        );
        return;
      }
      if (this.displayingType === DISPLAYING_CLUSTERS) {
        this.setCurrentClusterNavigation(params.data.uid);
        this.setNameCurrClusterNavigation(params.data.Name);
        this.setSelectedClusterRecordData(params.data);
        this.clusterOwnership = this.getSelectedClusterRecordData.Ownership;
        this.clusterOwnedBy = this.getSelectedClusterRecordData.ownedByName;
      } else {
        this.setCurrentProjectNavigation(params.data.uid);
        this.setNameCurrProjectNavigation(params.data.Name);
        this.setSelectedProjectRecordData(params.data);
        this.projectOwnership = this.getSelectedProjectRecordData.Ownership;
        this.projectOwnedBy = this.getSelectedProjectRecordData.ownedByName;
      }
      this.$router.push(`${this.$route.path}/${params.data.uid}`);
      this.isLoading = false;
    },
    // Event handler on reports table is row clicked
    async onReportsRowClickedAgGrid(event) {
      const selectedNode = event.data;
      const disabledReport = selectedNode.disable || false;
      if (disabledReport) {
        await this.$alert('Exciting Premium content awaits! Please take a moment to verify your subscription', 'Premium Report', 'info');
        return;
      }
      if (selectedNode.linkReportId.length > 0) {
        // Linked report opening on a new window
        const routeUrl = this.$router.resolve({
          name: 'ReportViewer',
          params: {
            projectId: selectedNode.linkProjectId,
            reportId: selectedNode.linkReportId,
            clusterId: selectedNode.linkClusterId,
          },
        }).href;
        window.open(routeUrl, '_blank');
        return;
      }
      const reportId = selectedNode.uid ? selectedNode.uid : selectedNode.reportId;
      const editAccess = this.isAllowEditNavigation ? true : false;
      this.setAllowEditReportViewer(editAccess);
      this.$router.push({
        name: 'ReportViewer',
        params: {
          projectId: this.getCurrentProjectNavigation,
          reportId: reportId,
          clusterId: this.getCurrentClusterNavigation,
        },
      });
    },
    async shareElement() {
      if (this.displayingType === DISPLAYING_REPORTS) {
        const uncompleteReports = this.verifySelectedComplete();
        if (uncompleteReports.length > 0) {
          this.$alert(
            'Incomplete report cannot be shared individually. Make sure to edit default report name, date of test, hypothesis, protocol and equipment fields of the report.',
            'Incomplete report',
            'error',
          );
          return;
        }
        const linkedReports = await this.verifyLinkedReport();
        if (linkedReports > 0) {
          // TODO(inlcude the functionality of ask user if linked reports are found and share them too)
          this.$alert('Cannot share individually reports with linked data (coming soon)', 'Linked report', 'info');
          return;
        }
        const reportIds = this.getSelectedInfo();
        this.setConfigSharingWindow({
          visibility: true,
          id: reportIds,
          elementName: 'Selected Reports',
          type: 'report',
        });
      } else if (this.displayingType === DISPLAYING_CLUSTERS) {
        const selectedRow = this.gridApi.getSelectedNodes();
        const elementName = selectedRow[0].data.Name.replace(`  ${IconSharing}`, '');
        this.setConfigSharingWindow({
          visibility: true,
          id: [{ id: selectedRow[0].data.uid, name: selectedRow[0].data.Name }],
          elementName: elementName,
          type: 'cluster',
        });
      } else if (this.displayingType === DISPLAYING_PROJECTS) {
        await this.$alert('Sharing project functionality is coming soon. Meanwhile, please share the cluster', 'Coming soon', 'info', {
          confirmButtonText: 'Got it!',
        });
        return;
      }
    },
    verifySelectedComplete() {
      const selectedUncompleteReports = [];
      const selectedRows = this.gridApi.getSelectedNodes();
      for (const selectedRow of selectedRows) {
        const DBReportObject = this.dictIdReports[selectedRow.data.internalCounter];
        if (ReportInfo.isReportUncomplete(this, DBReportObject)) {
          selectedUncompleteReports.push(DBReportObject);
        }
      }
      return selectedUncompleteReports;
    },
    async verifyLinkedReport() {
      try {
        this.isLoading = true;
        const selectedRows = this.gridApi.getSelectedNodes();
        for (const selectedRow of selectedRows) {
          const DBReportObject = this.dictIdReports[selectedRow.data.internalCounter];
          const reportObjt = await this.readSingleReportMiddleware({
            clusterId: this.getCurrentClusterNavigation,
            projectId: this.getCurrentProjectNavigation,
            reportId: DBReportObject.id,
          });
          if (typeof reportObjt !== 'undefined' && reportObjt !== null) {
            return (reportObjt.reportLinked || []).length;
          } else {
            return 1;
          }
        }
        return 0;
      } catch {
        const errTitle = 'Error retrieving information';
        const errText = 'Error retrieving report information. Please try again in a few seconds';
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
      } finally {
        this.isLoading = false;
      }
    },
    getSelectedInfo() {
      const selectedReports = [];
      const selectedRows = this.gridApi.getSelectedNodes();
      for (const selectedRow of selectedRows) {
        const DBReportObject = this.dictIdReports[selectedRow.data.internalCounter];
        selectedReports.push({
          id: DBReportObject.reportId,
          name: DBReportObject.name,
        });
      }
      return selectedReports;
    },
    async removeSharing() {
      this.$alert('This is a new functionality. Stay tuned!', 'Coming Soon', 'info');
    },
    async deleteSelected() {
      if (this.displayingType === DISPLAYING_CLUSTERS) {
        this.$alert('This is a new functionality. Stay tuned!', 'Coming soon!', 'info');
        return;
      } else if (this.displayingType === DISPLAYING_PROJECTS) {
        this.$alert('This is a new functionality. Stay tuned!', 'Coming soon!', 'info');
        return;
      } else if (this.displayingType === DISPLAYING_REPORTS) {
        this.setForceUpdReprtsTableReportViewer(true);
        let selectedRows = this.gridApi.getSelectedNodes();
        if (selectedRows.length === 0) {
          const infoTitle = 'Removing reports';
          const infoText = 'Please select at least one report';
          const infoZone = 'Reports';
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.INFO, infoTitle, infoText, infoZone);
          return;
        }
        const mssgReports = selectedRows.length === 1 ? `You will remove report '${selectedRows[0].data.descriptiveId}'` : 'You will remove multiple reports';
        try {
          await this.$confirm(mssgReports + '. Are you sure?', 'Remove Confirmation', 'question', {
            confirmButtonText: 'Remove',
          });
        } catch {
          return;
        }
        try {
          this.isLoading = true;
          let errors = 0;
          for (let j = 0; j < selectedRows.length; j++) {
            const reportId = selectedRows[j].data.uid;
            const success = await this.removeReportMiddleware({
              clusterId: this.getCurrentClusterNavigation,
              projectId: this.getCurrentProjectNavigation,
              reportId: reportId,
            });
            if (!success) {
              const errTitle = 'Error removing the report file';
              const errText = `Error removing the report '${selectedRows[j].data.descriptiveId}'. Please try again in a few seconds`;
              this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
              errors++;
            }
          }
          // Print message at the end of the process
          let messageAlert = selectedRows.length > 1 ? `${selectedRows.length} reports ` : `Report '${selectedRows[0].data.descriptiveId}' `;
          let titleAlert, typeAlert;
          if (errors === 0) {
            messageAlert += 'removed successfully';
            titleAlert = 'Success';
            typeAlert = 'success';
          } else if (errors === selectedRows.length) {
            messageAlert += 'could not be removed. Please try in a few seconds';
            titleAlert = 'Failed';
            typeAlert = 'error';
          } else {
            messageAlert += `removed but ${errors} failed. Please try in a few seconds.`;
            titleAlert = 'Warning';
            typeAlert = 'warning';
          }
          this.$alert(messageAlert, titleAlert, typeAlert);
        } catch {
          const errTitle = 'Error';
          const errText = 'Error while deleting reports, please try again';
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
        }
        this.isLoading = false;
        this.setReportsTable(true);
      }
    },
    // Bound to either cluster, project or report addition methods
    addValue() {
      if (this.displayinTypeText === 'Cluster') {
        this.addCluster(); // Go to add cluster method if it is clusters page
      } else if (this.displayinTypeText === 'Project') {
        this.addProject(); // Go to add project method if it is projects page
      } else if (this.displayinTypeText === 'Report') {
        this.setForceUpdReprtsTableReportViewer(true);
        this.addReport(); // Go to add report method if it is reports page
      } else {
        const errText = 'You can only add Cluster, Project or Report. What resource do you want to add?';
        const errTitle = 'Contact the adminstrator';
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
      }
    },
    async addHyperinkReport() {
      let clusterName;
      try {
        clusterName = await this.$prompt('Input the URL of the report', '', 'Report URL', 'question');
      } catch {
        return;
      }
      const matchURL = /\/reportViewer\/([\dA-Z]+)\/([\dA-Z]+)\/report\/([\dA-Z]+)/i.exec(clusterName);
      if (!matchURL || matchURL === null) {
        await this.$alert(
          'Invalid URL report, please paste the URL of your report from ReportViewer. Example: https://djuli.zimmerpeacock.no/reportViewer/<cluster-id>/<project-id>/report/<report-id>',
          'Error',
          'error',
        );
        return;
      }
      const clusterId = matchURL[1];
      const projectId = matchURL[2];
      const reportId = matchURL[3];
      this.isLoading = true;
      const createReportReq = await this.addHyperlinkReportMiddleware({
        clusterId: this.getCurrentClusterNavigation,
        projectId: this.getCurrentProjectNavigation,
        clusterIdLink: clusterId,
        projectIdLink: projectId,
        reportIdLink: reportId,
      });
      if (!createReportReq.success) {
        if (createReportReq.code === 403) {
          await this.$alert(createReportReq.message, createReportReq.title || 'Insufficient Permission', 'info');
        } else if (createReportReq.code === 422) {
          await this.$alert(createReportReq.message, createReportReq.title || 'Link not allowed', 'info');
        } else if (createReportReq.message) {
          await this.$alert(createReportReq.message, createReportReq.title || 'Error creating the hyperlink', 'info');
        } else {
          const errTitle = 'Error creating the hyperlink';
          const errText = 'Error connecting with the server. Please try again in a few minutes.';
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
        }
        this.isLoading = false;
        return null;
      }
      this.isLoading = false;
      await this.setReportsTable(true);
    },
    // Bound to either cluster, project or report edit methods
    editValue() {
      //TODO:
      if (this.displayinTypeText === 'Cluster' || this.displayinTypeText === 'Project') {
        this.editClusterOrProject();
      } else if (this.displayinTypeText === 'Report') {
        this.editReport();
      } else {
        const errText = 'You can only edit Cluster, Project or Report.';
        const errTitle = 'Go back and select the right resource to edit.';
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
      }
    },

    // A method to add cluster
    async addCluster() {
      const numClus = this.getClusterDataMiddleware.clusterList.length + 1;
      let clusterName;
      try {
        clusterName = await this.$prompt('Input the name of the cluster', `My Cluster ${numClus}`, 'Cluster Name', 'question');
      } catch {
        return;
      }
      try {
        const response = await this.addClusterMiddleware({
          clusterName: clusterName,
        });
        if (!response.success) {
          if (response.code === 403) {
            await this.$alert(response.message, response.title || 'Unlock Premium Access', 'info');
            return;
          }
          throw 'Error in the server response';
        }
        await this.updateShowedElements(true, 'Active');
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.$event, 'Cluster Creation', 'Cluster is created successfully!', notifyZone);
      } catch (error) {
        const errText = 'Navigation.Error sending the information to the server, please try in a few minutes';
        const errTitle = 'Conection failed';
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
      }
    },
    // A method to add project
    async addProject() {
      let clusterOBJ = this.getClusterSelectedObjNavigation;
      let projectName;
      try {
        projectName = await this.$prompt('Input the name of the project', `My Project ${this.getClusterSelectedObjNavigation.projects.length + 1}`, 'Project Name', 'question');
      } catch {
        return;
      }
      this.setLoadingClustProyNavigation(true);
      try {
        const response = await this.addProjectMiddleware({
          projectName: projectName,
          clusterId: clusterOBJ.clusterId,
        });
        if (!response.success) {
          if (response.code === 403) {
            await this.$alert(response.message, response.title || 'Unlock Premium Access', 'info');
            return;
          }
          throw 'Error in the server response';
        }
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.$event, 'Project Creation', 'Project is created successfully!', notifyZone);
      } catch (error) {
        const errText = 'Error sending the information to the server, please try in a few minutes.';
        const errTitle = 'Conection failed';
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
      } finally {
        this.setLoadingClustProyNavigation(false);
      }
    },
    async combineReports() {
      const idDBReport = await this.commonAddReport();
      if (idDBReport === null || typeof idDBReport === 'undefined') return;
      this.$set(this.getCurrentReportViewer, 'reportLinked', []);
      this.selectedRows = this.gridApi.getSelectedNodes();
      for (let j = 0; j < this.selectedRows.length; j++) {
        const shortIdComp = String(this.selectedRows[j].data.shortId);
        const internalCounter = this.selectedRows[j].data.internalCounter;
        if (shortIdComp.includes(IdentifierComparison)) {
          const errTitle = 'Error creating the comparative report';
          const errText = `It is not possible to link comparative reports. Element ${shortIdComp}`;
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
          continue;
        }
        this.getCurrentReportViewer.reportLinked.push(this.dictIdReports[internalCounter].reportId);
      }
      this.setConfigReportModifiedReportViewer();
      this.setAutoSaveReportViewer(true);
      this.$router.push({
        name: 'ReportViewer',
        params: {
          projectId: this.getCurrentProjectNavigation,
          reportId: idDBReport,
          clusterId: this.getCurrentClusterNavigation,
        },
      });
      this.isLoading = false;
    },
    async commonAddReport() {
      this.isLoading = true;
      const createReportReq = await this.addReportMiddleware({
        clusterId: this.getCurrentClusterNavigation,
        projectId: this.getCurrentProjectNavigation,
        report_name: `New report ${this.getNameCurrProjectNavigation}`,
      });
      if (!createReportReq.success) {
        if (createReportReq.code === 403) {
          await this.$alert(createReportReq.message, createReportReq.title || 'Insufficient Permission', 'info');
        } else {
          const errTitle = 'Error creating the report';
          const errText = 'Error connecting with the server. Please try again in a few minutes.';
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
        }
        this.isLoading = false;
        return null;
      }
      this.setDragModeReportViewer(true);
      this.setToolSideBarVisibleReportViewer(false);
      this.setAllowEditReportViewer(true);
      homogenizeReport(this.getCurrentReportViewer);
      ReportInfo.getConfigFromBackendPayload(this, this.getCurrentReportViewer);
      return createReportReq.id;
    },
    // A method to add a report
    async addReport() {
      const idDBReport = await this.commonAddReport();
      if (idDBReport === null || typeof idDBReport === 'undefined') return;
      this.$router.push({
        name: 'ReportViewer',
        params: {
          projectId: this.getCurrentProjectNavigation,
          reportId: idDBReport,
          clusterId: this.getCurrentClusterNavigation,
        },
      });
      this.isLoading = false;
    },
    async editClusterOrProject() {
      //Used to edit cluster or project
      let isProject = false;
      if (this.displayingType === DISPLAYING_PROJECTS) {
        isProject = true; //typeof(this.selectedRecord.parent)!=='undefined' //Check if it is a project
      }
      let response;
      let newName;
      const type = isProject ? 'Project' : 'Cluster';
      const containsSharing = this.selectedRecord.oldName.includes(`  ${IconSharing}`); //Validate if the element is sharing, so we remove the icon and add at the end of the function
      try {
        newName = await this.$prompt(
          `Input the name of the ${type.toLowerCase()}`,
          this.selectedRecord.oldName.replace(`  ${IconSharing}`, ''), //Remove the sharing icon
          `${type} Name`,
          'question',
        );
      } catch {
        return;
      }
      try {
        this.isLoading = true;
        if (isProject) {
          //It is a project
          response = await this.editProjectMiddleware({
            projectId: this.selectedRecord.projectId,
            clusterId: this.getCurrentClusterNavigation,
            newText: newName,
          });
        } else {
          //It is a cluster
          response = await this.editClusterMiddleware({
            clusterId: this.selectedRecord.clusterId,
            newText: newName,
          });
        }
      } catch (error) {
        response = false;
      }
      this.isLoading = false;
      if (response.success) {
        const formattedNewName = containsSharing ? `${newName}  ${IconSharing}` : newName;
        this.selectedRecord.text = formattedNewName;
        await this.$alert(`${type} name changed to '${newName}'`, 'Success', 'success');
        await this.updateShowedElements(true, this.displayedType);
      } else {
        if (response.code === 403) {
          await this.$alert(response.message, response.title || 'Unlock Premium Access', 'info');
          return;
        }
        const errText = 'Error updating the element, please try later.';
        const errTitle = 'Conection failed';
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
        return;
      }
    },
    async editReport() {
      //Used to edit report
      if (!this.selectedRecord.reportId) {
        const errTitle = 'Error incomplete report';
        const errText = 'Error retrieving the data of the report report from the server. Refresh the table and try again.';
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
        return;
      }
      if (this.selectedRecord.oldName.includes('🔗')) {
        this.$alert('You cannot modify linked reports', 'Information', 'info');
        return;
      }
      let newName;
      try {
        newName = await this.$prompt(
          'Input the name of the report',
          this.selectedRecord.oldName.replace(`${IconSharing}  `, '').replace(`${IconIncompleteReport}  `, ''), //Remove extra icon
          'Report name',
          'question',
        );
      } catch {
        return;
      }
      this.isLoading = true;

      const reportObjt = await this.readSingleReportMiddleware({
        clusterId: this.getCurrentClusterNavigation,
        projectId: this.getCurrentProjectNavigation,
        reportId: this.selectedRecord.reportId,
      });
      if (reportObjt === null || typeof reportObjt === 'undefined') {
        if (this.getReportAccessTypeMiddleware.code === 403 && this.getReportAccessTypeMiddleware.accesstype === false) {
          this.state = this.NO_PERMISSION;
        } else {
          const errTitle = 'Error retrieving report';
          const errText = 'Error retrieving the report from the server. Try again in a few minutes.';
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
          return;
        }
      }
      reportObjt.name = newName;
      const reponseSaveReport = await this.updateReportMiddleware({
        clusterId: this.getCurrentClusterNavigation,
        report: reportObjt,
      });
      if (!reponseSaveReport) {
        this.$alert(`Error saving the new name '${newName}'. Please try again in a few seconds`, 'Error', 'error');
        return;
      }
      // Notify user if success
      await this.$alert(`Report name changed to '${newName}'`, 'Success', 'success');
      try {
        await this.setReportsTable(true);
      } catch (error) {
        const errText = 'Error updating the report, please try later.';
        const errTitle = 'Conection failed';
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
        return;
      } finally {
        this.isLoading = false;
      }
    },
    async showPopup() {
      this.showingPopup = true;
      const routeParams = this.$route.params.selection?.split('/');
      this.routeClusterId = routeParams[0];
      if (routeParams.length > 1) {
        this.routeProjectId = routeParams[1];
      }
      const ownerData = await this.readClusterOwnerDataMiddleware({
        clusterId: this.routeClusterId,
      });
      this.receiver = ownerData.email;
    },
    async closePopup() {
      this.showingPopup = false;
    },
    isValidEmail(inputValue) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(inputValue);
    },
    async sendAccessRequest() {
      this.closePopup(); // Close the current modal
      this.showingSendingRequest = true; // Show the "Sending Request" modal

      this.isLoading = true;
      const success = await this.readUserFullNameMiddlewareAuth({
        email: auth.currentUser.email,
      });
      let clusterId = null;
      let projectId = null;
      let reportId = null;
      let entityId = null;
      if (success && this.receiver && this.isValidEmail(this.receiver)) {
        const userData = this.getUserNameMiddlewareAuth;
        if (this.resourceType === 'Cluster') {
          clusterId = this.routeClusterId;
          projectId = null;
          reportId = null;
          entityId = this.routeClusterId;
        } else if (this.resourceType === 'Project') {
          clusterId = this.routeClusterId;
          projectId = this.routeProjectId;
          reportId = null;
          entityId = projectId;
        } else {
          clusterId = this.$route.params.clusterId;
          projectId = this.$route.params.projectId;
          reportId = this.$route.params.reportId;
          entityId = reportId;
        }
        const subject = `Request For Sharing the ${entityId} resource`;
        // Extract encrypted data and IV from the API response
        const encryptedName = userData.displayName;
        const encryptedEmail = userData.email;
        const secretKey = process.env.VUE_APP_ENCRYPTION_SECRET_KEY;
        const displayName = AES.decrypt(encryptedName, secretKey).toString(Utf8);
        const email = AES.decrypt(encryptedEmail, secretKey).toString(Utf8);
        const sender = {
          email: email || 'Email',
          name: displayName || 'Someone',
        };
        const message = this.messageBody;
        const linkObj = {
          clusterId: clusterId,
          projectId: projectId,
          reportId: reportId,
          entityId: entityId,
        };
        let responseRequest = null;
        if (
          sender !== null &&
          sender !== 'undefined' &&
          subject !== null &&
          this.receiver !== null &&
          this.receiver !== 'undefined' &&
          this.resourceType !== null &&
          linkObj !== null &&
          linkObj !== 'undefined'
        ) {
          responseRequest = await this.sendResourceAccessRequestMiddleware({
            sender: sender,
            subject: subject,
            receiver: this.receiver, // Change to known email for testing
            message: message,
            resourceType: this.resourceType,
            entityName: linkObj.entityId,
            linkObj: linkObj,
          });
        }
        if (responseRequest) {
          if (responseRequest.data.responseCreateRequest.success && responseRequest.data.responseSendEmail.success) {
            this.$alert(`${responseRequest.data.responseCreateRequest.message} and ${responseRequest.data.responseSendEmail.message}`, 'Request Successful!', 'success');
          } else if (!responseRequest.data.responseCreateRequest.success && responseRequest.data.responseSendEmail.success) {
            this.$alert(responseRequest.data.responseCreateRequest.message, 'Creating Request Failed!', 'error');
          } else if (responseRequest.data.responseCreateRequest.success && !responseRequest.data.responseSendEmail.success) {
            this.$alert(responseRequest.data.responseSendEmail.message, 'Sending Email Failed!', 'error');
          } else {
            this.$alert(`${responseRequest.data.responseCreateRequest.message} and ${responseRequest.data.responseSendEmail.message}`, 'Request Failed!', 'error');
          }
        } else if (responseRequest.code === 403) {
          await this.$alert(responseRequest.message, responseRequest.title || 'Unlock Premium Access', 'info');
        } else {
          this.$alert('There is a problem communicating with the server. Please try again!', 'Server Error!', 'error');
        }
      } else {
        if (!this.isValidEmail(this.receiver)) {
          this.emailValid = false;
          this.showingPopup = true;
        } else {
          this.$alert(`Either the user doesn't exist or you are not authorized to request the ${this.getCurrentReportViewer?.name} resource to the user!`, 'Unathorized To Request', 'error');
          return;
        }
      }
      try {
        // this.closePopup();
        this.email = '';
        this.message = '';
        this.emailValid = true;
      } catch (error) {
        const errTitle = 'Error creating the access request';
        const errText = 'Error creating the request in the server. Try again in a few minutes.';
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
        return false;
      } finally {
        this.isLoading = false;
        this.showingSendingRequest = false; // Hide the "Sending Request" modal
      }
    },
    getRowClass(params) {
      return params.data.disable ? 'disabled-row' : '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~ag-grid-community/dist/styles/ag-grid.css'; // Core grid CSS, always needed
@import '~ag-grid-community/dist/styles/ag-theme-alpine.css';
@import '~ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham-dark.css';
@import '~ag-grid-community/dist/styles/ag-theme-blue.css';
@import '~ag-grid-community/dist/styles/ag-theme-dark.css';
@import '~ag-grid-community/dist/styles/ag-theme-fresh.css';
@import '~ag-grid-community/dist/styles/ag-theme-material.css';
.welcome-mssg {
  margin: 0;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 22rem;
}

.djuliLogo-mssg {
  width: 15rem;
  margin-left: 3rem;
  opacity: 1;
}

.sharing-window {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 103;
}

.btn-common {
  box-shadow: 0 2px 4px 0 #aaa;
}

.header-welcome {
  font-size: 1.4rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.project-title {
  font-size: 1.75rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.action-cell {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 768px) {
  .ag-grid-container {
    width: 100%;
    height: 400px;
    display: flex;
    overflow: auto !important; /* Enable horizontal scrolling */
    // display: flex !important; /* Use flexbox to allow the grid to grow and shrink */
  }
}
.hand-cursor {
  cursor: pointer !important;
}
.sticker-container {
  position: relative !important;
}

.floating-card {
  position: absolute !important;
  top: 5px;
  right: 2px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  padding: 0%;
  background-color: #e9ecef;
}

.small-card {
  font-size: 9px;
  max-width: 100px;
}

.medium-card {
  font-size: 11px;
  max-width: 200px;
}

.large-card {
  font-size: 13px;
  max-width: 300px;
  max-height: 200px;
}

.centered-header {
  display: block;
  text-align: center;
}

.loading-animation {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  margin-top: 0.75rem;
}
.loading-card {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  background: #fff;
  border: 1.5px solid #4dbf45;
  border-radius: 24px;
  padding: 0.45rem 1.1rem;
  box-shadow: 0 2px 10px rgba(77, 191, 69, 0.15);
}
.loading-spinner {
  width: 1.25rem;
  height: 1.25rem;
  color: #4dbf45;
  border-width: 2px;
}
.loading-text {
  font-size: 0.88rem;
  font-weight: 500;
  color: #3a9e34;
  letter-spacing: 0.02em;
}
.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  padding: 0.3rem 0.85rem 0.3rem 0.6rem;
  border-radius: 20px;
  border: 1.5px solid #4dbf45;
  color: #3a9e34;
  font-size: 0.85rem;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.18s, color 0.18s;
}
.back-btn:hover {
  background: #4dbf45;
  color: #fff;
  text-decoration: none;
}
.bordered-button-group {
  border: 1px solid #ced4da; /* Adjust border properties as needed */
  border-radius: 4px; /* Adjust border radius if desired */
  padding: 5px;
}
::v-deep .disabled-row {
  opacity: 0.5;
}
</style>
